export const statiCandidatura ={
  bozza: 0,
  inoltrata: 1,
  validataIdonea: 2,
  validataNonIdonea: 3,
  sospesa: 4
};